export default "__VITE_ASSET__CYOOxZji__"